module.exports = __webpack_public_path__ + "static/media/image-client-new.4298f7c4.svg";